import { Container } from "@mui/material";
import SocialLinks from "../../components/SocialLinks";
import logo from "../../assets/logo.svg";

const FooterSection = () => {
  return (
    <section id="footer">
      <Container>
        <img src={logo} alt="loading-logo" style={{ height: "180px" }}></img>
        <h3>Rebel Tiger Club</h3>
        <SocialLinks></SocialLinks>
      </Container>
    </section>
  );
};

export default FooterSection;
